export default __webpack_public_path__ + "static/media/mode_cool_off.7ab17520.svg";